import { first } from "rxjs/operators";
import {
  MatDialog,
  MatDialogConfig,
  MAT_DIALOG_DATA,
} from "@angular/material/dialog";
import { Component, Input, OnInit } from "@angular/core";
import { AlertService } from "@app/_services";
import {
  LazyLoadEvent,
  MessageService,
  ConfirmationService,
} from "primeng/api";
import { EmployeeProfile } from "../employee-profile";
import { EmployeeProfileService } from "../employee-profile.service";
import { EmployeeProfileComponent } from "../employee-profile/employee-profile.component";

@Component({
    selector: "app-employee-profile-list",
    templateUrl: "./employee-profile-list.component.html",
    styleUrls: ["./employee-profile-list.component.css"],
    providers: [
        MessageService,
        ConfirmationService,
        { provide: MAT_DIALOG_DATA, useValue: {} },
    ],
    // make column heading sticky
    styles: [
        `
      :host ::ng-deep .p-datatable .p-datatable-thead > tr > th {
        position: -webkit-sticky;
        position: sticky;
        top: 0px;
      }

      @media screen and (max-width: 64em) {
        :host ::ng-deep .p-datatable .p-datatable-thead > tr > th {
          top: 99px;
        }
      }
    `,
    ],
    standalone: false
})
export class EmployeeProfileListComponent implements OnInit {
  genders: any;
  constructor(
    private employeeProfileService: EmployeeProfileService,
    private alertService: AlertService,
    private messageService: MessageService,
    private confirmationService: ConfirmationService,
    private dialog: MatDialog
  ) {
    this.taxStatuses = employeeProfileService.taxStatuses;
		this.taxExemptElects = employeeProfileService.taxExemptElects;
		this.termReasons = employeeProfileService.termReasons;
		this.payRateFreqs = employeeProfileService.payRateFreqs;
		this.contractOrPerms = employeeProfileService.contractOrPerms;
		this.salaryOrHourlys = employeeProfileService.salaryOrHourlys;
    this.genders = employeeProfileService.genders;
  }

  // data
  @Input() showFilter = true;
  @Input() showPagination = true;
  @Input() outlineNewButton = true;
  employeeProfiles: any;
  employeeProfile: EmployeeProfile;

  // paging
  first = 0;
  rows = 50;

  // list
  datasource: any;

  recordTotal: number;
  lazyLoadEvent: LazyLoadEvent;
  loading = true;
  multiSortMeta = [];

  // forms
  formLoading = false;

  taxStatuses: any;
	taxExemptElects: any;
	termReasons: any;
	payRateFreqs: any;
	contractOrPerms: any;
	salaryOrHourlys: any;

  columns: any[] = [
    { field: "firstName", header: "First Name", width: "auto" },
    { field: "lastName", header: "Last Name", width: "auto" },
    { field: "emailAddress", header: "Email Address", width: "auto" },
    { field: "perEmailAddress", header: "Personal Email Address", width: "auto" },
    { field: "mobilePhone", header: "Mobile Phone", width: "auto" },
    { field: "perMobilePhone", header: "Personal Mobile Phone", width: "auto" },
    { field: "positionName", header: "Position Name", width: "auto" },
    { field: "payRate", header: "Pay Rate", width: "auto" },
    { field: "contractOrPerm", header: "Contract or Permanent", width: "auto" },
    { field: "salaryOrHourly", header: "Salary Basis", width: "auto" },
    { field: "hireDate", header: "Hire Date", width: "auto" },
    { field: "startDate", header: "Start Date", width: "auto" },
    { field: "termDate", header: "Termination Date", width: "auto" },
  ];

  ngOnInit(): void {
    try {
      // default sort of list
      this.multiSortMeta = [];
      this.multiSortMeta.push({ field: "createDate", order: 0 });
    } catch (error) {
      console.log("Error: " + error);
    }
  }

  /*********
   * Delete Button
   *
   */
  onRowDelete(event: any) {
    console.log("onRowDelete: " + JSON.stringify(event));
    this.confirmationService.confirm({
      message: "Are you sure you want to delete Id# " + event.employeeProfileId + "?",
      header: "Confirm",
      icon: "pi pi-exclamation-triangle",
      accept: () => {
        this.formDelete(event);
      },
      reject: () => {
        this.messageService.add({
          severity: "info",
          summary: "Canceled",
          detail: "Delete canceled.",
          life: 3000,
        });
      },
    });
  }

  /*********
   * Lazy Load All Data
   *
   */
  loadLazy(event: LazyLoadEvent) {
    try {
      this.loading = true;
      this.lazyLoadEvent = event;

      console.log(
        " event.first:" +
          event.first +
          "  |  event.rows:" +
          event.rows +
          "  |  event.sortField:" +
          event.sortField +
          "  |  event.sortOrder:" +
          event.sortOrder +
          "  |  event.multiSortMeta:" +
          JSON.stringify(event.multiSortMeta) +
          "  |  event.globalFilter:" +
          event.globalFilter +
          "  |  event.filters:" +
          JSON.stringify(event.filters)
      );

      /*
       *
       * Default Sort
       */
      // https://stackoverflow.com/questions/679915/how-do-i-employeeProfile-for-an-empty-javascript-object
      // if we are NOT filtering and we are NOT sorting, apply a default sort
      if (Object.keys(event.filters).length === 0 && !event.multiSortMeta) {
        event.multiSortMeta = [];
        event.multiSortMeta.push({ field: "createDate", order: -1 });
      }

      const pageNumber = Math.round(event.first / event.rows);
      this.employeeProfileService
        .findByFilter(
          pageNumber,
          event.rows,
          event.sortField,
          event.sortOrder,
          event.multiSortMeta,
          event.globalFilter,
          event.filters
        )
        .pipe(first())
        .subscribe(
          (res: any) => {
            this.datasource = res.data.reviews;
            this.recordTotal = res.page.recordTotal;
            this.employeeProfiles = res.data.employeeProfiles;
            console.log(JSON.stringify(res.page));
          },
          (err: any) => {
            console.log("reviews list error!: " + JSON.stringify(err));
            this.alertService.error(err);
          },
          () => {
            this.loading = false;
          }
        );

      if (this.datasource) {
        this.employeeProfiles = this.datasource.slice(
          event.first,
          event.first + event.rows
        );
      }
    } catch (error) {
      console.log("loadLazy(" + event + ")" + error);
    }
  }

  getStatus() {
    return;
  }

  /*********
   * onRowSelect()
   * Used to handle row click (to edit, link, etc)
   */
  onRowSelect(event: any) {
    console.log("onRowSelect: " + JSON.stringify(event));
    this.onOpenFormEdit(event.data);
  }

  // handled in rate-bucket-form
  formAdd() {}

  /*********
   * formUpdate()
   * Used for row editing
   */
  formUpdate(employeeProfile: EmployeeProfile) {
    try {
      this.formLoading = true;
      this.employeeProfileService.update(employeeProfile).subscribe(
        (res: any) => {
          console.log("Rate-Bucket-Update SUCCESS: " + JSON.stringify(res));
          this.employeeProfiles.map((employeeProfile, i) => {
            if (employeeProfile.employeeProfileId === res.data.employeeProfile.employeeProfileId) {
              this.employeeProfiles[i] = res.data.employeeProfile;
            }
          });
          // this.alertService.success(res, true);
          this.messageService.add({
            severity: "success",
            summary: "Success",
            detail: res.message,
          });
        },
        (err: any) => {
          console.log("Rate-Bucket-Update FAIL: " + JSON.stringify(err));
          this.messageService.add({
            severity: "error",
            summary: JSON.stringify(err),
            life: 3000,
          });
        },
        () => {
          this.formLoading = false;
        }
      );
    } catch (error) {
      console.log("Form Invalid: " + JSON.stringify(error));
      this.alertService.error(error);
    }
  }

  /*********
   * formDelete()
   * Used for row editing
   */
  formDelete(employeeProfile: any) {
    try {
      // stop here if form is invalid
      console.log("Delete Submitted: " + JSON.stringify(employeeProfile));

      this.formLoading = true;
      this.employeeProfileService.delete(employeeProfile.employeeProfileId).subscribe(
        (res: any) => {
          console.log("Rate-Bucket-Delete SUCCESS: " + JSON.stringify(res));
          this.employeeProfiles.splice(this.employeeProfiles.indexOf(employeeProfile), 1);
          this.recordTotal = this.employeeProfiles.length;
          this.messageService.add({
            severity: "success",
            summary: "Successful",
            detail: "EmployeeProfile " + employeeProfile.employeeProfileId + " Deleted",
            life: 3000,
          });
        },
        (err: any) => {
          console.log("Rate-Bucket-Delete  FAIL: " + JSON.stringify(err));
          this.messageService.add({
            severity: "error",
            summary: "Delete Failed",
            detail:
              "EmployeeProfile " +
              employeeProfile.employeeProfileId +
              " could not be deleted.  Be sure there are no assigned properties to this bucket.",
            life: 3000,
          });
        },
        () => {
          this.formLoading = false;
        }
      );
    } catch (error) {
      console.log("Form Invalid: " + JSON.stringify(error));
      this.alertService.error(error);
    }
  }

  /*********
   * Add New Button
   *
   */
  onOpenFormAdd() {
    const dialogConfig = new MatDialogConfig();

    // settings
    dialogConfig.disableClose = false;
    dialogConfig.autoFocus = true;
    dialogConfig.hasBackdrop = true;
    dialogConfig.maxWidth = "60vw";
			dialogConfig.width = "40vw";

    // pass data, ie rateBuicket: this.shortTermRentalId,
    dialogConfig.data = {
      title: "Add Employee Profile",
    };

    // open the popup and get a reference to it called dialogRef
    const dialogRef = this.dialog.open(EmployeeProfileComponent, dialogConfig);

    // to receive the added element, subscribe to the eventEmitter we created 'doAdd' in the element to handle adding
    dialogRef.componentInstance.doAdd.subscribe((data) => {
      console.log("Dialog output:", data);

      // when we doAdd in the element, call this parent and update the list so it shows the added element to the database
      this.addEmployeeProfileCB(data);

      // close the dialogBox
      dialogRef.close();
    });
  }

  /*********
   * Edit Button
   *
   */
  onOpenFormEdit(employeeProfile: EmployeeProfile) {
    const dialogConfig = new MatDialogConfig();

    // settings
    dialogConfig.disableClose = false;
    dialogConfig.autoFocus = true;
    dialogConfig.hasBackdrop = true;
    dialogConfig.maxWidth = "60vw";
			dialogConfig.width = "40vw";

    // pass data, ie rateBuicket: this.shortTermRentalId,
    dialogConfig.data = {
      employeeProfile: employeeProfile,
      title: "Edit Employee Profile",
    };

    // open the popup and get a reference to it called dialogRef
    const dialogRef = this.dialog.open(EmployeeProfileComponent, dialogConfig);

    // to receive the added element, subscribe to the eventEmitter we created 'doUpdate' in the element to handle updating the list
    dialogRef.componentInstance.doUpdate.subscribe((data) => {
      console.log("Dialog output:", data);

      // when we doAdd in the element, call this parent and update the list so it shows the added element to the database
      this.updateEmployeeProfileCB(data);

      // close the dialogBox
      dialogRef.close();
    });

    dialogRef.componentInstance.doDelete.subscribe((data) => {
      console.log("Dialog output:", data);

      // when we doAdd in the element, call this parent and update the list so it shows the added element to the database
      this.deleteEmployeeProfileCB(data);

      // close the dialogBox
      dialogRef.close();
    });
  }

  /**
   *
   * Dialog from Form Callbacks
   * To edit the list show add/edit/delete in real time from the popup form
   *
   */
  addEmployeeProfileCB(employeeProfile: EmployeeProfile) {
    console.log("Adding EmployeeProfile: " + JSON.stringify(employeeProfile));
    // if we don't have a employeeProfiles array yet...
    if (!this.employeeProfiles) {
      this.employeeProfiles = [];
    }
    // unshift adds to the front of the array (), push adds to the back
    this.employeeProfiles.unshift(employeeProfile);

    // no idea what this is but it is required to update the array
    this.employeeProfiles = [...this.employeeProfiles];

    this.messageService.add({
      severity: "success",
      summary: "Success",
      detail: "EmployeeProfile " + employeeProfile.employeeProfileId + " Added",
      life: 3000,
    });
  }

  updateEmployeeProfileCB(employeeProfile: EmployeeProfile) {
    console.log("Updating EmployeeProfile: " + JSON.stringify(employeeProfile));
    let itemIndex = this.employeeProfiles.findIndex(
      (item: any) => item.employeeProfileId === employeeProfile.employeeProfileId
    );
    this.employeeProfiles[itemIndex] = employeeProfile;

    // no idea what this is but it is required to update the array
    this.employeeProfiles = [...this.employeeProfiles];

    this.messageService.add({
      severity: "success",
      summary: "Success",
      detail: "EmployeeProfile " + employeeProfile.employeeProfileId + " Updated",
      life: 3000,
    });
  }

  deleteEmployeeProfileCB(employeeProfile: EmployeeProfile) {
    console.log("Removing EmployeeProfile: " + employeeProfile);
    this.employeeProfiles.splice(this.employeeProfiles.indexOf(employeeProfile), 1);
    this.recordTotal = this.employeeProfiles.length;

    // no idea what this is but it is required to update the array
    this.employeeProfiles = [...this.employeeProfiles];

    this.messageService.add({
      severity: "success",
      summary: "Success",
      detail: "EmployeeProfile " + employeeProfile.employeeProfileId + " Deleted",
      life: 3000,
    });
  }

  /**********
   *
   * PAGINATOR FUNCTIONS
   */
  next() {
    this.first = this.first + this.rows;
  }
  prev() {
    this.first = this.first - this.rows;
  }
  reset() {
    this.first = 0;
  }
  isLastPage(): boolean {
    return this.employeeProfiles ? this.first === this.employeeProfiles.length - this.rows : true;
  }
  isFirstPage(): boolean {
    return this.employeeProfiles ? this.first === 0 : true;
  }

  getTaxStatusName(employeeProfile: any) {
    if (employeeProfile?.taxStatus) {
      const option = this.taxStatuses.find((e: any) => e.value == employeeProfile.taxStatus);
      return option.name;
    } else {
      return "";
    }
  }

	getTaxExemptElects(employeeProfile: any) {
    if (employeeProfile?.taxExemptElect) {
      const option = this.taxExemptElects.find((e: any) => e.value == employeeProfile.taxExemptElect);
      return option.name;
    } else {
      return "";
    }
  }

	getTermReasons(employeeProfile: any) {
    if (employeeProfile?.termReason) {
      const option = this.termReasons.find((e: any) => e.value == employeeProfile.termReason);
      return option.name;
    } else {
      return "";
    }
  }

	getPayRateFreqs(employeeProfile: any) {
    if (employeeProfile?.payRateFreq) {
      const option = this.payRateFreqs.find((e: any) => e.value == employeeProfile.payRateFreq);
      return option.name;
    } else {
      return "";
    }
  }

	getContractOrPerms(employeeProfile: any) {
    if (employeeProfile?.contractOrPerm) {
      const option = this.contractOrPerms.find((e: any) => e.value == employeeProfile.contractOrPerm);
      return option.name;
    } else {
      return "";
    }
  }

  getGendersName(employeeProfile: any) {
    if (employeeProfile?.gender) {
      const option = this.genders.find((e: any) => e.value == employeeProfile.gender);
      return option.name;
    } else {
      return "";
    }
  }

	getSalaryOrHourlys(employeeProfile: any) {
    if (employeeProfile?.salaryOrHourly) {
      const option = this.contractOrPerms.find((e: any) => e.value == employeeProfile.salaryOrHourly);
      return option.name;
    } else {
      return "";
    }
  }

  reloadPage() {
    window.location.reload();
  }

  showPaginator() {
    return true;
  }
}
